(function () {
  var slidesInitialized = false;

  // DOM observer：当 #variant-slides-root 被添加到 DOM 时重新应用网格样式
  var rootObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.id === 'variant-slides-root') {
            node.querySelectorAll('.variant-slides-track').forEach(ensureTrackGrid);
          } else if (node.querySelectorAll) {
            var innerRoot = node.querySelector('#variant-slides-root');
            if (innerRoot) {
              innerRoot.querySelectorAll('.variant-slides-track').forEach(ensureTrackGrid);
            }
          }
          if (node.classList && node.classList.contains('variant-slides-section')) {
            var t = node.querySelector('.variant-slides-track');
            if (t) ensureTrackGrid(t);
          }
        }
      });
    });
  });
  rootObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // 确保 track 使用平铺网格布局
  function ensureTrackGrid(track) {
    if (!track) return;
    track.style.setProperty('display', 'flex', 'important');
    track.style.setProperty('flex-wrap', 'wrap', 'important');
    track.style.setProperty('overflow-x', 'visible', 'important');
    track.style.setProperty('overflow-y', 'visible', 'important');
  }

  var variantSlidesReady = setInterval(function () {
    var selectEl = document.getElementById('product-selectors');
    if (!selectEl) return;

    // 检查是否已有 Liquid 渲染的选中项
    var existingSelection = document.querySelector('.variant-slide-item.is-selected');

    // 只有在完全没有选中项的情况下，才进行初始化选中
    if (!existingSelection && selectEl.selectedIndex < 0) {
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');
      var foundUrlVariant = false;
      
      if (urlVariantId) {
        for (var i = 0; i < selectEl.options.length; i++) {
          if (String(selectEl.options[i].value) === String(urlVariantId)) {
            selectEl.selectedIndex = i;
            foundUrlVariant = true;
            break;
          }
        }
      }

      if (!foundUrlVariant) {
        for (var fi = 0; fi < selectEl.options.length; fi++) {
          if (!selectEl.options[fi].disabled) {
            selectEl.selectedIndex = fi;
            break;
          }
        }
      }
    }
    if (selectEl.selectedIndex < 0 || !selectEl.value) return;
    
    // 初始化时给对应的 slide 加上 is-selected 类
    (function highlightInitialSlides() {
      var parts = selectEl.options[selectEl.selectedIndex].textContent.split(' / ');
      document.querySelectorAll('.variant-slides-section').forEach(function (section) {
        var idx = parseInt(section.getAttribute('data-option-index'));
        var value = (parts[idx] || '').trim();
        section.querySelectorAll('.variant-slide-item').forEach(function (item) {
          if (item.getAttribute('data-value') === value) {
            item.classList.add('is-selected');
            var label = section.querySelector('[data-option-selected-label]');
            if (label) label.textContent = value;
          }
        });
      });
    })();

    if (slidesInitialized) return;
    slidesInitialized = true;
    clearInterval(variantSlidesReady);

    // slides 已由 product-options.js 直接生成在 #variant-slides-root 中，无需搬运
    // console.log("[PO Debug variant-slides] Slides generated by product-options.js, initializing directly");
    initSlidesAfterMove(selectEl);
    return;

    function initSlidesAfterMove(selectEl) {
      var select = selectEl;

      // 强制所有 track 使用平铺网格布局
      document.querySelectorAll('.variant-slides-track').forEach(ensureTrackGrid);

      // Mark slides without images for padding fallback
      document.querySelectorAll('.variant-slide-item').forEach(function (item) {
        if (!item.querySelector('.variant-slide-image')) {
          item.classList.add('variant-slide-item--no-image');
        }
      });

      // Slide click handler: toggle selection, only one selected per track
      document.querySelectorAll('.variant-slide-item').forEach(function (item) {
        item.addEventListener('click', function () {
          if (item.classList.contains('is-sold-out')) {
            // console.log('[PO DEBUG variant-slides] Clicked item is sold out, skipping.');
            return;
          }

          // 如果点击的变体 ID 等于 base_var_id，直接触发 Open3DStudio 按钮
          var clickedVarId = item.getAttribute('data-variant-id');
          var poRoot = document.getElementById('product-options-root');
          if (poRoot && poRoot.__po_baseVarId && clickedVarId === String(poRoot.__po_baseVarId)) {
            // console.log('[PO DEBUG variant-slides] base_var_id matched, triggering Open3DStudio:', clickedVarId);
            var open3DBtn = document.getElementById('open3DStudioBtn');
            if (open3DBtn) {
              open3DBtn.click();
            }
            return;
          }

          var optionIndex = parseInt(item.getAttribute('data-option-index'));
          var value = item.getAttribute('data-value');
          var sectionTitle = item.closest('.variant-slides-section').querySelector('.variant-slides-title').textContent.trim();

          // console.log('[PO DEBUG variant-slides] User clicked:', {
          //   option: sectionTitle,
          //   value: value,
          //   index: optionIndex,
          //   currentSelected: item.classList.contains('is-selected')
          // });

          var track = item.closest('.variant-slides-track');
          if (!track) {
            console.error('[PO DEBUG variant-slides] Could not find parent track for item.');
            return;
          }

          // 如果点击的是已选中的 slide，取消选中
          if (item.classList.contains('is-selected')) {
            // console.log('[PO DEBUG variant-slides] Deselecting item.');
            item.classList.remove('is-selected');
            var label = document.querySelector('[data-option-selected-label="' + optionIndex + '"]');
            if (label) label.textContent = '';
          } else {
            // 取消同 track 下其他 slide 的选中状态
            // console.log('[PO DEBUG variant-slides] Selecting new item, clearing others in track.');
            track.querySelectorAll('.variant-slide-item').forEach(function (s) {
              s.classList.remove('is-selected');
            });
            item.classList.add('is-selected');

            var label = document.querySelector('[data-option-selected-label="' + optionIndex + '"]');
            if (label) label.textContent = value;
          }

          // 联动 step1 面板显示/隐藏
          syncPanelVisibility();

          // ===== 增强联动：同步点击 slide 到原生选择器（Swatch 或 Dropdown），确保主题 UI 完全同步 =====
          (function syncToNativeSelectors() {
            var optionName = sectionTitle.replace(':', '').replace('*', '').trim();
            var targetValue = value;
            
            // console.log('[PO DEBUG variant-slides] Syncing to native UI:', { option: optionName, value: targetValue });

            var found = false;

            // 1. 尝试同步 Swatch (Radio 按钮)
            var allSwatches = document.querySelectorAll('.swatch .swatch-element input[type="radio"], .product-form__input input[type="radio"]');
            for (var i = 0; i < allSwatches.length; i++) {
              var sw = allSwatches[i];
              if (sw.value === targetValue) {
                var swatchLabel = sw.closest('.swatch, .product-form__input')?.querySelector('.header, .form__label');
                if (swatchLabel && swatchLabel.textContent.replace('*', '').indexOf(optionName) !== -1) {
                   // console.log('[PO DEBUG variant-slides] ✅ Found matching swatch radio, clicking.');
                   sw.click();
                   found = true;
                   break;
                }
              }
            }

            // 2. 尝试同步 Dropdown (Select 元素) - Surfup/Dawn 常用
            if (!found) {
              var allWrappers = document.querySelectorAll('.selector-wrapper, .product-form__input--select');
              allWrappers.forEach(function(wrapper) {
                var label = wrapper.querySelector('label');
                if (label && label.textContent.replace('*', '').indexOf(optionName) !== -1) {
                  var select = wrapper.querySelector('select');
                  if (select) {
                    // console.log('[PO DEBUG variant-slides] ✅ Found matching native select, updating value to:', targetValue);
                    select.value = targetValue;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    found = true;
                  }
                }
              });
            }
            
            if (found) {
               // 触发价格区域的扫描信号
               setTimeout(function() {
                  var prices = document.querySelector('.prices');
                  if (prices) {
                    prices.dispatchEvent(new Event('change', { bubbles: true }));
                  }
               }, 100);
            } else {
               // console.log('[PO DEBUG variant-slides] ℹ️ No matching native UI component found for:', targetValue);
            }
          })();

          // 通过 window.__po_variantProduct 精确匹配变体
          var matchedVariant = findMatchingVariant();
          // console.log('[PO DEBUG variant-slides] Variant matching result:', matchedVariant ? matchedVariant.id : 'NO MATCH');

          // 兜底：如果匹配失败，尝试从 select.value 反向查找变体
          if (!matchedVariant && select.value) {
            // console.log('[PO DEBUG variant-slides] Attempting reverse match from select value:', select.value);
            var product = window.__po_variantProduct;
            if (product && product.variants) {
              for (var vi = 0; vi < product.variants.length; vi++) {
                if (String(product.variants[vi].id) === String(select.value)) {
                  matchedVariant = product.variants[vi];
                  // console.log('[PO DEBUG variant-slides] ✅ Reverse match found:', matchedVariant.id);
                  break;
                }
              }
            }
          }

          updateSelectFromSlides(select, matchedVariant);

          // ===== 事件联动：通过更新 select 的值并触发 change 事件，让 product-variants 中的 selectCallback 统一处理价格更新 =====
          if (matchedVariant) {
            // 更新 select 的选中值
            select.value = matchedVariant.id;
              // console.log('[PO DEBUG variant-slides] Updated hidden select value to:', select.value);
            
            // 调用 selectCallback（负责 SKU、库存状态、价格更新）
            if (window.__po_selectCallback) {
                // console.log('[PO DEBUG variant-slides] Triggering global selectCallback for:', matchedVariant.id);
              try {
                window.__po_selectCallback(matchedVariant, null);
              } catch (e) {
                console.error('[PO DEBUG variant-slides] ❌ selectCallback error:', e);
              }
            }

            // 同步触发 select 的 change 事件
            if (typeof $ !== 'undefined') {
              // console.log('[PO DEBUG variant-slides] Triggering jQuery change on select');
              $(select).trigger('change');
            } else {
              // console.log('[PO DEBUG variant-slides] Dispatching native change event on select');
              var evt = new Event('change', { bubbles: true });
              select.dispatchEvent(evt);
            }

            // [PO FIX] 主动通知 product-options 脚本更新基准价，不再单纯依赖 change 事件监听
            if (typeof window.__po_triggerUpdateFromSelect === 'function') {
               // console.log('[PO DEBUG variant-slides] Directly calling window.__po_triggerUpdateFromSelect');
               window.__po_triggerUpdateFromSelect();
            }
          } else {
            // console.log('[PO DEBUG variant-slides] No variant matched. Checking if we need to reset select.');
            var hasSelection = document.querySelector('.variant-slide-item.is-selected');
            if (!hasSelection) {
              // console.log('[PO DEBUG variant-slides] Total reset: no items selected, resetting select index to 0.');
              select.selectedIndex = 0;
              if (typeof $ !== 'undefined') {
                $(select).trigger('change');
              } else {
                var evt = new Event('change', { bubbles: true });
                select.dispatchEvent(evt);
              }
            }
          }
        });
      });

      function syncPanelVisibility() {
        var slidesRoot = document.getElementById('variant-slides-root');
        if (!slidesRoot) return;
        var hasSelection = slidesRoot.querySelector('.variant-slide-item.is-selected') !== null;

        // 从 .product-options 容器或其父级获取 unifiedItems
        var productOptions = slidesRoot.closest('.product-options');
        if (!productOptions) return;
        var unifiedItems = productOptions.__po_unifiedItems || (productOptions.parentNode && productOptions.parentNode.__po_unifiedItems) || null;
        if (!unifiedItems || !Array.isArray(unifiedItems)) {
          // 兜底：如果没有 unifiedItems，回退到 data-step-label 方式
          var allSteps = document.querySelectorAll('.product-options__custom-step[data-step-label]:not([data-step-label="want_an_expert"])');
          if (allSteps.length === 0) return;
          var firstStep = allSteps[0];
          var others = [];
          for (var i = 1; i < allSteps.length; i++) { others.push(allSteps[i]); }
          if (hasSelection) {
            firstStep.style.display = '';
            others.forEach(function (s) { s.style.display = 'none'; });
          } else {
            firstStep.style.display = 'none';
            others.forEach(function (s) { s.style.display = ''; });
          }
          return;
        }

        // 有选中状态：隐藏 position < 35 的控件面板（variant-slides 自身除外）
        // 无选中状态：显示这些面板
        // unifiedItems.forEach(function (item) {
        //   if (item.position >= 35 || item.position === 1 || item.position===3) return;
        //   if (item.kind === 'variant-slides') return; // variant-slides 自身始终可见
        //   var el = item.__po_domElement;
        //   if (el) {
        //     el.style.display = hasSelection ? 'none' : '';
        //   }
        // });
      }

      /**
       * 从所有 variant-slides-section 中收集已选中的选项值（按 option_index 分组），
       * 然后在 window.__po_variantProduct.variants 中精确匹配对应变体。
       * 比旧版用 indexOf 模糊匹配 option title 的方式可靠得多。
       */
      function findMatchingVariant() {
        var selectedByIndex = {}; // { optionIndex: value }
        document.querySelectorAll('.variant-slides-section').forEach(function (section) {
          var idx = parseInt(section.getAttribute('data-option-index'));
          if (isNaN(idx)) return;
          var selectedItem = section.querySelector('.variant-slide-item.is-selected');
          if (selectedItem) {
            selectedByIndex[idx] = selectedItem.getAttribute('data-value');
          }
        });

        var selectedIndices = Object.keys(selectedByIndex);
        if (selectedIndices.length === 0) return null;

        var product = window.__po_variantProduct;
        if (!product || !product.variants) return null;

        var variants = product.variants;
        for (var vi = 0; vi < variants.length; vi++) {
          var v = variants[vi];
          var match = selectedIndices.every(function (idx) {
            return v.options[idx] === selectedByIndex[idx];
          });
          if (match) return v;
        }

        // 未找到完全匹配，尝试返回第一个匹配部分选项值的变体
        if (selectedIndices.length === 1) {
          var idx = selectedIndices[0];
          for (var vj = 0; vj < variants.length; vj++) {
            if (variants[vj].options[idx] === selectedByIndex[idx]) {
              console.warn('[PO DEBUG variant-slides] Partial match (no full combo):', variants[vj].id);
              return variants[vj];
            }
          }
        }

        console.warn('[PO DEBUG variant-slides] No variant matched:', selectedByIndex);
        return null;
      }

      function updateSelectFromSlides(sel, matchedVariant) {
        if (matchedVariant) {
          sel.value = matchedVariant.id;
        } else {
          // 没有选中任何 slide → 重置 select
          var hasSelection = document.querySelector('.variant-slide-item.is-selected');
          if (!hasSelection) {
            sel.selectedIndex = 0;
          }
        }
      }

      // 无默认选中状态，所有 selected-label 初始化为空
      document.querySelectorAll('[data-option-selected-label]').forEach(function (label) {
        label.textContent = '';
      });

      // 初始同步面板可见性
      syncPanelVisibility();

      // Listen for external select changes
      select.addEventListener('change', function () {
        var selIdx = select.selectedIndex;
        if (selIdx < 0) return;
        var opt = select.options[selIdx];
        if (!opt || !opt.textContent) return;
        var parts = opt.textContent.split(' / ');
        document.querySelectorAll('.variant-slides-section').forEach(function (section) {
          var idx = parseInt(section.getAttribute('data-option-index'));
          if (isNaN(idx)) return;
          var value = parts[idx] || '';
          var track = section.querySelector('.variant-slides-track');
          if (!track) return;
          track.querySelectorAll('.variant-slide-item').forEach(function (item) {
            if (item.getAttribute('data-value') === value) {
              item.classList.add('is-selected');
            } else {
              item.classList.remove('is-selected');
            }
          });
          var label = section.querySelector('[data-option-selected-label]');
          if (label) label.textContent = value;
        });
      });
    } // end initSlidesAfterMove
  }, 100);
})();
